import { Address } from '@31third/common';

export class AuthState {
  public refreshToken: string | undefined;
  public accessToken: string | undefined;
  public loggedIn: boolean;
  public loggedInWallet: Address | undefined;
  public admin: boolean;
}
